import { environment } from "../config/environment";
import { customFetch } from "./Auth";
import { Auth } from "aws-amplify";

let cachedUserDetails = null;
let pendingUserDetailsPromise = null;
let cachedTokenValue = null;

const getUserDetails = async () => {
  const currentTokenValue = localStorage.getItem("token");
  if (cachedTokenValue !== currentTokenValue) {
    cachedUserDetails = null;
    pendingUserDetailsPromise = null;
    cachedTokenValue = currentTokenValue;
  }

  if (cachedUserDetails) {
    return cachedUserDetails;
  }

  if (!pendingUserDetailsPromise) {
    pendingUserDetailsPromise = Auth.currentAuthenticatedUser()
      .then((user) => {
        const userAttributes = user?.attributes || {};
        const orgAttribute = String(userAttributes["custom:org"] || "").trim();
        const username = String(
          user?.username || userAttributes["cognito:username"] || ""
        ).trim();
        cachedUserDetails = { username, orgAttribute };
        return cachedUserDetails;
      })
      .finally(() => {
        pendingUserDetailsPromise = null;
      });
  }

  return pendingUserDetailsPromise;
};

export const trackExternalEvent = async (
  eventName,
  { includeKnowtex = false } = {}
) => {
  const normalizedEventName = String(eventName || "").trim();
  if (!normalizedEventName) {
    return;
  }

  try {
    const { username, orgAttribute } = await getUserDetails();
    if (!username || (!includeKnowtex && orgAttribute === "Knowtex")) {
      return;
    }

    const response = await customFetch(
      `${environment.apiUrl}/logging/event?username=${encodeURIComponent(username)}&event=${encodeURIComponent(normalizedEventName)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token"),
        },
      }
    );

    if (!response.ok) {
      console.error(
        `Failed to log external event ${normalizedEventName}: ${response.status}`
      );
    }
  } catch (error) {
    // Logging must not interrupt the user's workflow.
    console.error("Error logging external event:", error);
  }
};

export const trackLogin = async () => {
  await trackExternalEvent("login");
};

export const trackPageView = async () => {
  const path = window.location.pathname;
  await trackExternalEvent(`view: ${path}`);
};